import cx from "classnames"
import PropTypes from "prop-types"
import React from "react"
import Container from "components/Container"
import Img from "components/Img"
import * as css from "./Section.module.css"

function Section({
  children,
  className,
  fluid,
  inverted,
  padding,
  noPadding,
  containerless,
  narrow,
  background,
  backgroundPosition,
  backgroundClassName,
}) {
  const classNames = cx(
    css.section,
    {
      [css.noPadding]: !!noPadding,
      [css.paddingExtraLight]: padding === "extraLight",
      [css.paddingLight]: padding === "light",
      [css.paddingHeavy]: padding === "heavy",
      [css.inverted]: inverted,
      [css.hasBackground]: !!background,
    },
    className
  )

  // eslint-disable-next-line no-nested-ternary
  const maxSize = fluid ? "mobile" : narrow ? "tablet" : undefined

  return (
    <section className={classNames}>
      {background && (
        <Img
          image={background}
          className={cx(css.backgroundImage, backgroundClassName)}
          style={
            backgroundPosition
              ? { objectPosition: backgroundPosition }
              : undefined
          }
        />
      )}
      {containerless ? (
        children
      ) : (
        <Container maxSize={maxSize}>{children}</Container>
      )}
    </section>
  )
}

Section.propTypes = {
  /** Children */
  children: PropTypes.node.isRequired,
  /** Additional className(s) */
  className: PropTypes.string,
  /** Determine the padding */
  padding: PropTypes.oneOf(["extraLight", "light", "heavy"]),
  /** If true, removes all padding */
  noPadding: PropTypes.bool,
  /** If true, the container will be fluid */
  fluid: PropTypes.bool,
  /** If true, the section will not render a container */
  containerless: PropTypes.bool,
  /** If true, the container will be narrower */
  narrow: PropTypes.bool,
  /** Fixed sharp image background */
  background: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  /** Position of background (defaults to "center center"; @see object-position CSS rule) */
  backgroundPosition: PropTypes.string,
  /** Class name to add to the background image */
  backgroundClassName: PropTypes.string,
}

export default Section
